var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 128,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.48 41.6C134.954 41.6 136.96 43.6057 136.96 46.08C136.96 48.5542 134.954 50.56 132.48 50.56H106.88C109.354 50.56 111.36 52.5657 111.36 55.04C111.36 57.5142 109.354 59.52 106.88 59.52H120.96C123.434 59.52 125.44 61.5257 125.44 64C125.44 66.4742 123.434 68.48 120.96 68.48H114.449C111.329 68.48 108.8 70.4857 108.8 72.96C108.8 74.6095 110.08 76.1028 112.64 77.44C115.114 77.44 117.12 79.4457 117.12 81.92C117.12 84.3942 115.114 86.4 112.64 86.4H59.5201C57.0458 86.4 55.0401 84.3942 55.0401 81.92C55.0401 79.4457 57.0458 77.44 59.5201 77.44H34.5601C32.0858 77.44 30.0801 75.4342 30.0801 72.96C30.0801 70.4857 32.0858 68.48 34.5601 68.48H60.1601C62.6343 68.48 64.6401 66.4742 64.6401 64C64.6401 61.5257 62.6343 59.52 60.1601 59.52H44.1601C41.6858 59.52 39.6801 57.5142 39.6801 55.04C39.6801 52.5657 41.6858 50.56 44.1601 50.56H69.7601C67.2858 50.56 65.2801 48.5542 65.2801 46.08C65.2801 43.6057 67.2858 41.6 69.7601 41.6H132.48ZM132.48 59.52C134.954 59.52 136.96 61.5257 136.96 64C136.96 66.4742 134.954 68.48 132.48 68.48C130.006 68.48 128 66.4742 128 64C128 61.5257 130.006 59.52 132.48 59.52Z",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1202 85.12C88.9612 85.12 98.5602 75.521 98.5602 63.68C98.5602 51.839 88.9612 42.24 77.1202 42.24C65.2792 42.24 55.6802 51.839 55.6802 63.68C55.6802 75.521 65.2792 85.12 77.1202 85.12Z",
    fill: "#F3F7FF",
    stroke: "#05294F",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6847 80.3161C74.8103 80.5238 75.9554 80.6318 77.1202 80.64C86.4869 80.64 94.0802 73.0467 94.0802 63.68C94.0802 54.3132 86.4869 46.72 77.1202 46.72C74.714 46.72 72.4249 47.221 70.3514 48.1245C66.7482 49.6946 63.7964 52.4799 62.0136 55.9628C60.8286 58.2777 60.1602 60.9008 60.1602 63.68C60.1602 66.2016 60.7105 68.5946 61.6975 70.7456C62.4022 72.2813 63.3295 73.6936 64.4381 74.9411",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6847 80.3161C74.8103 80.5238 75.9554 80.6318 77.1202 80.64C86.4869 80.64 94.0802 73.0467 94.0802 63.68C94.0802 54.3132 86.4869 46.72 77.1202 46.72C74.714 46.72 72.4249 47.221 70.3514 48.1245C66.7482 49.6946 63.7964 52.4799 62.0136 55.9628C60.8286 58.2777 60.1602 60.9008 60.1602 63.68C60.1602 66.2016 60.7105 68.5946 61.6975 70.7456C62.4022 72.2813 63.3295 73.6936 64.4381 74.9411",
    stroke: "#05294F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4307 76.8478C67.8055 77.9652 69.3586 78.8717 71.0409 79.5178",
    stroke: "#05294F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7202 80.64L98.5602 84.48",
    stroke: "#05294F",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9398 83.8594C96.7284 85.0708 96.7284 87.0347 97.9398 88.2461L105.034 95.3407C106.246 96.552 108.21 96.552 109.421 95.3407C110.632 94.1293 110.632 92.1654 109.421 90.954L102.326 83.8594C101.115 82.6481 99.1511 82.6481 97.9398 83.8594Z",
    fill: "#E8F0FE",
    stroke: "#05294F",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.12 85.12L108.16 92.16",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.96 56.3201C72.96 63.7428 78.9773 69.7601 86.4 69.7601C87.8582 69.7601 89.2621 69.5279 90.5768 69.0984C88.4308 74.4238 83.2144 78.1829 77.12 78.1829C69.1103 78.1829 62.6172 71.6898 62.6172 63.6801C62.6172 56.4222 67.9486 50.4095 74.9088 49.3447C73.6723 51.3788 72.96 53.7662 72.96 56.3201Z",
    fill: "#E8F0FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4403 51.84C76.6253 51.84 75.8291 51.9201 75.059 52.073M72.7329 52.7847C68.3547 54.6245 65.2803 58.9532 65.2803 64",
    stroke: "#05294F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.472 63.8575H106.24M115.52 58.88H104.527H115.52ZM120 58.88H118.578H120Z",
    stroke: "#05294F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8726 77.9374H48.6401M50.8801 72.3199H39.8876H50.8801ZM36.1601 72.3199H33.4585H36.1601Z",
    stroke: "#05294F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.e4ec504722ad7e0e7d27c39b17e19af5.svg";
export { ForwardRef as ReactComponent };